import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';

// Keep credentials in component memory and replace the history entry on mount.
// Analytics centrally excludes these routes, including during initial render.
export default function useUrlToken() {
  const [params, setParams] = useSearchParams();
  const [token] = useState(() => params.get('token') || '');
  useEffect(() => {
    if (!params.has('token')) return;
    const clean = new URLSearchParams(params);
    clean.delete('token');
    setParams(clean, { replace: true });
  }, [params, setParams]);
  return token;
}
